import React from "react";
import Headline from "./Headline";
import { Image, notification } from "antd";
import HomeLink from "../../widgets/HomeLink";
import { Link, useParams } from "react-router-dom";
import AlbumsApi from "../../api-services/albums-api.service";

const bannerPath = '/iceholidays-assets/images/gallery_cover.png';

function withParams(Component) {
  return props => <Component {...props} params={useParams()}/>;
}

class GalleryShowPage extends React.Component <{params}>  {
  api = new AlbumsApi;

  state = {
    album: {cover: "", name: "", photos: []},
    breadcrumbs: [
      { title: <HomeLink/>},
      { title: <Link to="/web/gallery">Gallery</Link> }
    ]
  }

  componentDidMount() {
    this.api.getAlbum(this.props.params.id)
    .then(album => {
      const breadcrumb = this.state.breadcrumbs;
      breadcrumb.push({title: <span>{album.name}</span>})
      this.setState({album})
    })
    .catch(error => {
      notification.error({ message: 'An error occured while loading album.'});
    });
  }


  render(){
    const {album, breadcrumbs}=this.state;
    return (
      <div id="gallery-show" className="gd-series-tour-page">
        <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            {album.name}
          </span>
        </Headline>

        <div className="gd-series-tour-page_body">
          <div className="gallery">
            <Image.PreviewGroup>
              {
                album.photos.map((image:any) => <Image src={image.url}/>)
              }
            </Image.PreviewGroup>
          </div>
        </div>

      </div>
    )
  }
}


export default withParams(GalleryShowPage);